<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            History Penilaian
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <penilaianCalonPenanggungJawab
                :dataPJO="dataPJO"
                :isResume="isResume"
              />
              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN ADMINISTRASI
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianAdmin"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.bobot == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianAdmin) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianAdmin) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN MATERI PRESENTASI
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianMateri"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.skor == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianMateri) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianMateri) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    PENILAIAN KOMPETENSI TEKNIS CALON PJO
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 7%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 73%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 10%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianKompetensi"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.skor == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              item.skor == null ? "N/A" : item.skor.toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            colspan="2"
                          >
                            Total
                          </td>
                          <td style="background: #ebecec">
                            {{ totalBobot(dataPenilaianKompetensi) }}
                          </td>
                          <td style="background: #ebecec">
                            {{ totalSkor(dataPenilaianKompetensi) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    RESUME PENILAIAN
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 5%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 55%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Bobot
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Skor
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in dataPenilaianResume"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.aspek }}</td>
                          <td>
                            {{ item.bobot == null ? "N/A" : item.bobot + "%" }}
                          </td>
                          <td>
                            {{
                              index == 0
                                ? skorAdmin
                                : index == 1
                                ? skorMateri
                                : index == 2
                                ? skorKompetensi
                                : "N/A"
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            style="background: #ebecec; text-align: center"
                            class="fs-5"
                            colspan="3"
                          >
                            Nilai Calon PJO
                          </td>
                          <td style="background: #ebecec" class="fs-5">
                            {{ skorResume.toFixed(2) }}
                          </td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="skorResume.toFixed(2) > 90"
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Lulus (dilanjutkan dengan pengesahan PJO oleh KTT)
                          </td>
                          <td class="text-center">&gt; 90</td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="
                                skorResume.toFixed(2) >= 65 &&
                                skorResume.toFixed(2) <= 90
                              "
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Perbaikan Minor (disubmit paling lambat 1 minggu)
                          </td>
                          <td class="text-center">65 ≤ Nilai ≤ 90</td>
                        </tr>
                        <tr>
                          <td class="text-center">
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 2rem; color: #02a12d"
                              v-if="skorResume.toFixed(2) < 65"
                            />
                            <font-awesome-icon
                              icon="fa-solid fa-circle-check"
                              style="height: 1rem; color: #b2afaf"
                              v-else
                            />
                          </td>
                          <td colspan="2">
                            Presentasi Ulang (paling lambat 2 minggu)
                          </td>
                          <td class="text-center">&lt; 65</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12">
                  <p
                    class="mb-3 mt-4"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    LEMBAR PENGESAHAN
                  </p>
                  <div class="evaluation-table-container">
                    <table class="evaluation-table">
                      <thead>
                        <tr class="evaluation-table-heading">
                          <th style="background-color: #f8d7da; width: 5%">
                            No.
                          </th>
                          <th style="background-color: #f8d7da; width: 20%">
                            Nama
                          </th>
                          <th style="background-color: #f8d7da; width: 30%">
                            Aspek Penilaian
                          </th>
                          <th style="background-color: #f8d7da; width: 30%">
                            Departemen/Jabatan
                          </th>
                          <th style="background-color: #f8d7da; width: 15%">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(
                            dataPengesahan, dataKey, dataIndex
                          ) in lembarPengesahan"
                          :key="dataKey"
                        >
                          <tr
                            v-for="(item, index) in dataPengesahan"
                            :key="index"
                          >
                            <td>{{ index === 0 ? dataIndex + 1 : "" }}</td>
                            <td>{{ index === 0 ? item.namaKustodian : "" }}</td>
                            <td>
                              {{
                                item.aspek != null
                                  ? capitalized(item.aspek)
                                  : "-"
                              }}
                            </td>
                            <td>{{ item.department }} - {{ item.jabatan }}</td>
                            <td class="text-center">
                              <img
                                src="../../../assets/icons/close-64-old.png"
                                v-if="item.submitDate != null"
                                alt=""
                                style="width: 25%; height: auto"
                              />
                              <img
                                src="../../../assets/icons/close-64-old.png"
                                v-else
                                alt=""
                                style="width: 25%; height: auto"
                              />
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "@/GlobalDataMixin";
import penilaianCalonPenanggungJawab from "@/pages/sio/penilaian/penilaianCalonPenanggungJawab.vue";
// import SidebarComponent from "@/components/SideBar.vue";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
// import Swal from "sweetalert2"
import {
  API_BASE_URL,
  CMS_GET_HISTORY_PANJADWALAN,
  CMS_GET_HISTORY_PENILAIAN,
  CMS_GET_HISTORY_PENILAIAN_RESUME,
  // CMS_GET_HISTORY_PENILAIAN,
} from "@/constants";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
const url_get_history_penilaian_resume =
  API_BASE_URL + CMS_GET_HISTORY_PENILAIAN_RESUME;
const url_get_history_penilaian = API_BASE_URL + CMS_GET_HISTORY_PENILAIAN;
const url_get_history_penjadwalan = API_BASE_URL + CMS_GET_HISTORY_PANJADWALAN;

export default {
  mixins: [GlobalDataMixin],
  name: "historyPenilaian",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    penilaianCalonPenanggungJawab,
  },
  props: {},
  data() {
    return {
      isResume: true,
      isLoading: true,
      statusSio: null,
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      // idPenjadwalan: null,
      dataPenilaianAdmin: null,
      dataPenilaianKompetensi: null,
      dataPenilaianMateri: null,
      skorAdmin: 0,
      skorKompetensi: 0,
      skorMateri: 0,
      bobotAdmin: 0,
      bobotKompetensi: 0,
      bobotMateri: 0,
      skorResume: 0,
      dataPenilaianResume: [
        {
          aspek: "Penilaian Administratif",
          bobot: 40,
        },
        {
          aspek: "Penilaian Materi Presentasi",
          bobot: 30,
        },
        {
          aspek: "Penilaian Kompetensi Teknis Calon PJO",
          bobot: 30,
        },
      ],
      lembarPengesahan: null,
      idSio: null,
      idPenjadwalan: null,
    };
  },
  mounted() {
    this.idSio = this.$route.params.id;
    this.getPenjadwalan(this.idSio);
  },
  computed: {},
  methods: {
    capitalized(name) {
      const capitalizedFirst = name[0].toUpperCase();
      const rest = name.slice(1);

      return capitalizedFirst + rest;
    },
    totalBobot(arr) {
      let totbobot = 0;
      if (arr != null) {
        for (let x = 0; x < arr.length; x++) {
          if (arr[x].skor != null) totbobot += arr[x].bobot;
        }
      }

      return totbobot + "%";
    },
    totalSkor(arr) {
      let totskor = 0;
      let totbobot = 0;
      if (arr != null) {
        for (let x = 0; x < arr.length; x++) {
          if (arr[x].skor != null) {
            totskor += (arr[x].skor * arr[x].bobot) / 100;
            totbobot += arr[x].bobot;
          }
        }
      }
      totskor = (totskor / totbobot) * 100;
      return totskor.toFixed(2);
    },
    getResume(id_penjadwalan) {
      let bodyJson = {
        idPenjadwalan: id_penjadwalan,
      };
      axios
        .post(url_get_history_penilaian_resume, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response getResume : ", response);
          // console.log("data : ", response.data)
          if (response != null) {
            let dta = response.data;
            this.dataPenilaianAdmin = dta.administrasi;
            this.dataPenilaianKompetensi = dta.kompetensi;
            this.dataPenilaianMateri = dta.presentasi;
            this.skorAdmin = this.totalSkor(this.dataPenilaianAdmin);
            this.skorKompetensi = this.totalSkor(this.dataPenilaianKompetensi);
            this.skorMateri = this.totalSkor(this.dataPenilaianMateri);
            this.bobotAdmin = this.totalBobot(this.dataPenilaianAdmin);
            this.bobotKompetensi = this.totalBobot(
              this.dataPenilaianKompetensi
            );
            this.bobotMateri = this.totalBobot(this.dataPenilaianMateri);

            this.skorResume =
              this.skorAdmin * (this.dataPenilaianResume[0].bobot / 100) +
              this.skorMateri * (this.dataPenilaianResume[1].bobot / 100) +
              this.skorKompetensi * (this.dataPenilaianResume[2].bobot / 100);
            this.lembarPengesahan = this.groupDataByKustodian(dta.kustodian);
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("error getResume : ", error);
          alert("error getResume");
          this.isLoading = false;
        });
    },
    getPenilaianDetail(idPenjadawalan) {
      let bodyJson = {
        id: idPenjadawalan,
      };

      axios
        .get(url_get_history_penilaian, {
          params: bodyJson,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            this.dataPJO.nama = dt.pjo;
            this.dataPJO.perusahaan = dt.perusahaan;
            this.dataPJO.tanggalPresentasi = dt.schedule;
            this.statusSio = dt.statusSio;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail : ", error);
          alert("error getPenilaianDetail : ", error);
        })
        .then(() => {});
    },
    groupDataByKustodian(data) {
      return data.reduce((groups, item) => {
        const key = item.namaKustodian;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    },
    getPenjadwalan(id_sio) {
      let bodyJson = {
        idSio: id_sio,
      };

      axios
        .post(url_get_history_penjadwalan, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.idPenjadwalan = response.data.id;
          this.getPenilaianDetail(this.idPenjadwalan);
          this.getResume(this.idPenjadwalan);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
